module.exports = __webpack_public_path__ + "static/media/b-social-twitter.65f62fd8.png";